/** @format */

export const InfoLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.3337 12H14.667V9.33335L17.3337 9.33335V12ZM17.3337 22.6667H14.667V14.6667H17.3337L17.3337 22.6667ZM16.0137 29.3334C23.3737 29.3334 29.3337 23.36 29.3337 16C29.3337 8.64002 23.3737 2.66669 16.0137 2.66669C8.64033 2.66669 2.66699 8.64002 2.66699 16C2.66699 23.36 8.64032 29.3334 16.0137 29.3334ZM16.0003 5.33335C21.8937 5.33335 26.667 10.1067 26.667 16C26.667 21.8934 21.8937 26.6667 16.0003 26.6667C10.107 26.6667 5.33366 21.8934 5.33366 16C5.33366 10.1067 10.107 5.33335 16.0003 5.33335Z"
                fill={color}
            />
        </svg>
    );
};
